module.exports = __webpack_public_path__ + "assets/img/a7165eac5b040fa8015535f4d56ae970.png";